import React, { CSSProperties } from 'react';

type Props = {
  style?: CSSProperties;
  fill?: string;
  width?: string | number;
  className?: string;
  viewBox?: string;
};

const SVG: React.FC<Props> = ({
  style = {},
  fill = '#000',
  width = '100%',
  className = '',
  viewBox = '0 0 320 192',
}) => (
  <svg
    width={width}
    style={style}
    height={width}
    viewBox={viewBox}
    xmlns="http://www.w3.org/2000/svg"
    className={`svg-icon ${className || ''}`}
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <g id="bed-solid" transform="translate(-1408 -150)">
      <path
        fill={fill}
        id="bed-solid-2"
        data-name="bed-solid"
        d="M88,160a40,40,0,1,0-40-40A40.047,40.047,0,0,0,88,160ZM264,96H152a8,8,0,0,0-8,8v72H32V72a8,8,0,0,0-8-8H8a8,8,0,0,0-8,8V248a8,8,0,0,0,8,8H24a8,8,0,0,0,8-8V224H288v24a8,8,0,0,0,8,8h16a8,8,0,0,0,8-8V152A56,56,0,0,0,264,96Z"
        transform="translate(1408 86)"
      />
    </g>
  </svg>
);

export default SVG;
